// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__i0Auu","requiredAsterisk":"Info_requiredAsterisk__1coo6"};